var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _g, _g2, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 730.723 672.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 82.824,
    y1: 55.369,
    x2: 696.913,
    y2: 55.369,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 696.672,
    y1: 55.702,
    x2: 696.672,
    y2: 656.7,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 77.891,
    y1: 593.332,
    x2: 691.98,
    y2: 593.332,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 82.719,
    y1: 656.279,
    x2: 697.169,
    y2: 656.279,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 631.251,
    y1: 662.282,
    x2: 631.251,
    y2: 49.515,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 143.443,
    y1: 662.015,
    x2: 143.443,
    y2: 53.184,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 83.904,
    y1: 656.75,
    x2: 83.904,
    y2: 55.375,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 87.04,
    y1: 119.428,
    x2: 701.129,
    y2: 119.428,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 94.752,
    y1: 359.41,
    x2: 100.752,
    y2: 359.41,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.744,
    y1: 359.41,
    x2: 682.388,
    y2: 359.41,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 11.992 11.992",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 688.384,
    y1: 359.41,
    x2: 694.384,
    y2: 359.41,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 390.887,
    y1: 661.211,
    x2: 390.887,
    y2: 655.211,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.887,
    y1: 642.977,
    x2: 390.887,
    y2: 61.872,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.234 12.234",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.887,
    y1: 55.755,
    x2: 390.887,
    y2: 49.755,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(24.254 93.862)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(24.735 274.566)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(25.258 473.924)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(24.406 647.654)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(93.234 40.811)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(259.08 40.768)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(457.277 40.25)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(621.259 40.176)",
    fontFamily: "MyriadPro-Regular, 'Myriad Pro'",
    fontSize: 48
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "112.941 111.272 101.873 100.973 102.18 78.068 109.405 72.841 119.09 72.841 124.931 79.144 131.849 90.212 126.315 101.28 112.941 111.272",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "113.462 644.949 102.345 633.833 102.195 616.107 108.204 605.291 120.222 605.291 131.939 630.228 113.462 644.949",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "667.551 646.536 685.682 628.406 674.575 606.573 661.476 605.814 656.255 618.059 655.97 635.335 667.551 646.536",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "667.898 113.364 655.504 100.734 655.859 78.543 663.177 72.169 674.036 71.933 680.41 78.898 685.84 90.583 679.584 103.449 667.898 113.364",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontContainer);
export default __webpack_public_path__ + "static/media/Front Container.dc140a1b18bc29392b4a7fe04c477019.svg";
export { ForwardRef as ReactComponent };